import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=57ce415b&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ce415b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57ce415b')) {
      api.createRecord('57ce415b', component.options)
    } else {
      api.reload('57ce415b', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=57ce415b&scoped=true&", function () {
      api.rerender('57ce415b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2dRjAEyj5XSA4/JS/comp/SearchFilterTokens.vue"
export default component.exports